import React from "react";
import {
    Container,
    // Row, Col, Card
} from 'reactstrap'

import Dashheader from "components/Headers/Dashheader"
import SuspicionCountLogs from "components/SuspicionCount/SuspicionCountLogs";

import { Mixpanel } from "../../../Mixpanel/mixpanel"
import jwt_decode from "jwt-decode";

import { connect } from 'react-redux';

const mapStateToProps = state => {
    return {
        outlet: state.outletCode.outletCode,
        time: state.time.time,
    };
};

class SuspicionCountTab extends React.Component {
    constructor(props) {
        super(props)
        Mixpanel.track('Theft Tab', { distinct_id: jwt_decode(localStorage.getItem('act')).email, email: jwt_decode(localStorage.getItem('act')).email })
        Mixpanel.time_event('Theft Tab Time', { distinct_id: jwt_decode(localStorage.getItem('act')).email, email: jwt_decode(localStorage.getItem('act')).email })
    }
    componentWillUnmount() {
        Mixpanel.track('Theft Tab Time', { distinct_id: jwt_decode(localStorage.getItem('act')).email, email: jwt_decode(localStorage.getItem('act')).email })
    }

    render() {
        return (
            <>
                <Dashheader title="Suspicion Count" />
                <Container className="mt--6" fluid>
                    <SuspicionCountLogs />
                </Container>
            </>
        );
    }
}

export default connect(
    mapStateToProps,
)(SuspicionCountTab);